import { createFileRoute } from "@tanstack/react-router"
import BuyPlanCapacityTab from "~/components/purchase-plan/BuyPlanCapacityTab"
import CapacityPlanningTab from "~/components/purchase-plan/CapacityPlanningTab"
import { usePageTracking } from "~/hooks/usePageTracking"
import { useSupplyPlanContext } from "~/context/SupplyPlanProvider"
import { useFlags } from "~/features/feature-flags"

export const Route = createFileRoute(
  "/_auth/procurement/supply-plan/$purchasePlanId/_layout/capacity",
)({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Supply Plan - Capacity")
  const { isFashion } = useSupplyPlanContext()
  const { noosSupplyPlan: noosSupplyPlanFlag } = useFlags()

  // Fashion is always on the unified capacity tab; NOOS still switches on its own flag.
  const enabled = isFashion || !!noosSupplyPlanFlag
  return enabled ? <BuyPlanCapacityTab /> : <CapacityPlanningTab />
}
